import { Tooltip } from "../../../utils/Tooltip";
import { Stack } from "rsuite";

export const NextCleaningSection = ({monthsToNextCleaning, enercostpenAvgPre, enercostpenSum}) => {

    const getRecommendedDateOfCleaning = () => {
      if (monthsToNextCleaning === undefined) {
        return undefined;
      }
      var date = new Date();
      date.setMonth(date.getMonth() + monthsToNextCleaning);
      return date.toLocaleString("en-US", { month: "long", year: "numeric" });
    }

    const formatPenalty = (value) =>
        Math.round(Number(value)).toLocaleString("en-US");

    const renderCostPenalty = () => {
        if (monthsToNextCleaning >= 0 && !!enercostpenAvgPre) {
            return (
                <div className="mt-3" style={{ color: "var(--base-color)", fontSize: '16px', textAlign: 'center'  }}>
                    <span>Projected Energy Cost Penalty:&nbsp;
                        <span style={{ color: monthsToNextCleaning !== 0 ? "var(--base-color)" : "red"}}>${formatPenalty(enercostpenAvgPre)} /Month</span>
                    </span>
                    <Tooltip
                        className="ml-2"
                        id="my-tooltip-pen-est"
                        content={<p>Estimated monthly energy cost increase if the coil is not cleaned by the recommended date, base on current fouling conditions.</p>}
                    />
               </div>
            )
        } else if (monthsToNextCleaning < 0 && !!enercostpenSum) {
            return (
                <div className="mt-3" style={{ color: "var(--base-color)", fontSize: '16px', textAlign: 'center' }}>
                    <span>Cumulative Energy Cost Penalty:&nbsp;
                        <span style={{ color: "red"}}>${formatPenalty(enercostpenSum)}</span>
                    </span>
                    <Tooltip
                        className="ml-2"
                        id="my-tooltip-pen-sum"
                        content={<p>Total additional energy cost incurred due to operating beyond the recommended cleaning interval.</p>}
                    />
              </div>
            )
        }
        return null;
    }

    return (
        <>
            <h3 className="mt-4" style={{ fontSize: "28px", textAlign: "center" }} >
                {monthsToNextCleaning >= 0
                    ? (<>
                        <span>Months to Next Cleaning</span>
                        <Tooltip
                            className="ml-2"
                            id="my-tooltip-months-to-clean"
                            content={<p>Represents the recommended coil cleaning time frame to minimize overall operating and maintenance costs.</p>}
                            />
                        </>
                    )
                    : (<>
                        <span style={{ color: "red" }}>Months Past Target Cleaning</span>
                        <Tooltip
                            className="ml-2"
                            id="my-tooltip-months-to-clean"
                            content={<p>Recommended Date: {getRecommendedDateOfCleaning()}.</p>}
                        />
                        </>
                    )
                }
            </h3>
            <div className="big-number mb-0" style={{ color: monthsToNextCleaning > 0 ? "black" : "red"}}>
                {Math.abs(monthsToNextCleaning)}
            </div>
            {monthsToNextCleaning >= 0 && (
                <Stack direction="row" alignItems="baseline" className="mb-3">
                    <h3 style={{ fontSize: "28px", color: monthsToNextCleaning === 0 ? "red" : "var(--base-color)", fontWeight: 400 }}>
                        <span>Target month:</span>
                        <span className="ml-2" style={{ fontSize: "28px" }}>{getRecommendedDateOfCleaning()}</span>
                    </h3>
                </Stack>
            )}
            {monthsToNextCleaning <= 6 && (
            <div>
            {renderCostPenalty()}
            </div>
            )}
        </>
    )
}
